import React from "react";
import { ComponentEnum } from "src/common/enum";
import { Box, Chip, Paper, Button } from "@mui/material";


interface ComponentPickerProps {
  onSelect: (component: any) => void;
  onClose: () => void;
}

export const ComponentPicker: React.FC<ComponentPickerProps> = (props) => {
  const { onSelect, onClose } = props;

  return (
    <Paper elevation={0} className="component-picker">
      <Box mt={2} display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1}>
        {ComponentEnum.map((comp) => (
          <Chip key={comp.id} label={comp.name} variant="outlined" onClick={() => onSelect(comp)} />
        ))}
      </Box>
      <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
        <Button onClick={onClose}>Cancel</Button>
      </Box>
    </Paper>
  );
};
